module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/@babel/runtime/regenerator/index.js
// module id = 3
// module chunks = 3